import Component from 'vue-class-component';
import Vue from 'vue';
import {Fragment} from 'vue-fragment';
import {Watch} from 'vue-property-decorator';

@Component({
  props: {
    myDataUrl: String,
    myExtranetDataUrl: String,
    logoutUrl: String,
    loginUrl: String,
    username: String,
    firstName: String,
    lastName: String,
    label: Object,
    isExtranet: Boolean,
    state: String,
  },
  components: {Fragment},
})
export default class LoginMobile extends Vue {
  myDataUrl?: string;
  myExtranetDataUrl?: string;
  logoutUrl?: string;
  loginUrl?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  label?: {myData: string, logout: string, loggedInAs: string};
  isExtranet?: boolean;
  state?: string;

  @Watch('state')
  onStateChanged(value: string) {
    const replaceElement = $('.js-login-box-replace-mobile');
    replaceElement.show();
    if (value === 'loggedIn') {
      this.isExtranet ? this.replaceForExtranet() : this.replaceForWorldWide();
    }
  }

  replaceForExtranet() {
    $('#mobileNav').find('li[data-replace]').each((index, el) => {
      if (el.dataset.replace === 'login-mydata' && this.label) {
        el.innerHTML = `<a href="${this.myExtranetDataUrl}">${this.label.myData}</a>`;
      }
      if (el.dataset.replace === 'login-name' && this.label) {
        el.innerHTML = `<a href="#">${this.label.loggedInAs} ${this.firstName} ${this.lastName}</a>`;
      }
      if (el.dataset.replace === 'login-logout' && this.label) {
        el.innerHTML = `<a href="${this.logoutUrl}">${this.label.logout}</a>`;
      }
    });
  }

  replaceForWorldWide() {
    $('#mobileNav').find('li[data-replace]').each((index, el) => {
      if (el.dataset.replace === 'login-mydata' && this.label) {
        el.innerHTML = `<a href="${this.myDataUrl}">${this.label.myData}</a>`;
      }
      if (el.dataset.replace === 'login-name' && this.label) {
        el.innerHTML = `<a href="#">${this.label.loggedInAs} ${this.username}</a>`;
      }
      if (el.dataset.replace === 'login-logout' && this.label) {
        el.innerHTML = `<a href="${this.logoutUrl}">${this.label.logout}</a>`;
      }
    });
  }
}
